<template>
  <div class="media-container">
    <div class="media">
      <media-player :issue="issue" :share="false" :collections-header="collectionsHeader" :header="true"></media-player>
    </div>
    <div class="slides-container">
      <div class="nav-top" @click="slideUp()":class="{hidden: hidden_top}"><i class="icon icon-arrow-up-large"></i></div>
      <div class="slides-data" :style="'margin-top:' + scrollPos + 'px;'">
        <div v-for="(slide, index) in figures">
          <img v-bind:class="{slide: true, active: selectedId === index}"
               :src="slide.optimized_urls.small"
               :target="slide.optimized_urls.hero"
               v-on:click="selectThis(index, $event)"
               @load="loadImg()"
          />
        </div>
      </div>
      <div class="nav-bottom" @click="slideDown()" :class="{hidden: hidden_bottom}"><i class="icon icon-arrow-down-large"></i></div>
    </div>
  </div>
</template>

<script>
  import MediaPlayer from '@/components/shared/MediaPlayerComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  export default {
    name: 'media-container',
    components: {
      MediaPlayer
    },
    mixins: [ UtilityMixin ],
    props: ['issue', 'figures', 'collectionsHeader'],
    data () {
      return {
        selectedId: 0,
        selectedUrl: this.getStaticPath('img/temp/slide-1.jpg'),
        scrollPos: 0,
        containerHeight: 0,
        dataHeight: 0,
        hidden_top: true,
        hidden_bottom: true
      }
    },
    methods: { // TODO temp method for returm temp issue cover image path, must be removed after use rest service
      selectThis (slideId, $event) {
        this.selectedUrl = $event.target.target
        this.selectedId = slideId
      },
      loadImg () {
        this.containerHeight = this.$el.querySelector('.slides-container').offsetHeight
        this.dataHeight = this.$el.querySelector('.slides-container .slides-data').offsetHeight
        if (this.dataHeight > this.containerHeight) {
          this.hidden_bottom = false
        }
      },
      slideUp () {
        this.containerHeight = this.$el.querySelector('.slides-container').offsetHeight
        this.dataHeight = this.$el.querySelector('.slides-container .slides-data').offsetHeight
        if (this.scrollPos < -1 * this.containerHeight) {
          this.scrollPos += this.containerHeight
          this.hidden_bottom = false
        } else {
          this.scrollPos = 0
          this.hidden_top = true
        }
      },
      slideDown () {
        this.containerHeight = this.$el.querySelector('.slides-container').offsetHeight
        this.dataHeight = this.$el.querySelector('.slides-container .slides-data').offsetHeight
        if (this.dataHeight + this.scrollPos > 2 * this.containerHeight) {
          this.scrollPos -= this.containerHeight
          this.hidden_top = false
        } else {
          this.scrollPos = this.containerHeight - this.dataHeight
          this.hidden_bottom = true
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .nav-top, .nav-bottom {
    height: 30px;
    width: 100%;
    background-color: rgba($primary-color, 0.7);
    position: absolute;
    text-align: center;
    cursor: pointer;
    &.hidden {
      display: none;
    }
  }
  .nav-bottom {
    bottom: 0px;
  }
  .nav-top {
    top: 0px;
  }
  .slides-container::-webkit-scrollbar {
    width: 5px;
    height: 8px;
    background-color: #aaa
  }
  .slides-container::-webkit-scrollbar-thumb {
    background-color: black;
    outline: 1px solid slategrey;
  }

  .media-container {
    display: table;
    margin-bottom: 16.5px;
    background-color: $white;
    width: 100%;
  }
  .media {
    display: table-cell;
    vertical-align: top;
    width: 82%;
    background-color: $white;
    background-size: cover;
    position: relative;
    border: 1px solid #aaa;
  video {
    width: 100%;
  }
  }
  .slides-container {
    height: 402px;
    position: relative;
    overflow-y: hidden;
    max-width: 160px;
    img {
      cursor: pointer;
      border: 2px solid $white;
      width: 100%;
      &.active {
         border: 4px solid $slider-border;
       }
    }
    .slides-data {
      transition: margin-top 0.3s;
    }
  }
</style>



// WEBPACK FOOTER //
// MediaContainerComponent.vue?83d99f8c